module.exports = __webpack_public_path__ + "img/9788959761029.8557b244.jpg";